import { createTermTagManager } from '../../utils/createTermTagManager';

export const phoneTagManager = createTermTagManager({
  jsonQueryKey: 'contact',
  template: `Телефон %s`,
  id: 'phone',
});
